import "./portfolio.css";
import CreatableSelect from "react-select/creatable";
import React, {useState, useRef} from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import {Link} from "react-router-dom";
import PromoBanner from "../../pages/promoBanner.js";
import Divider from "@mui/material/Divider";
import Footer from "../footer.js";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import UserAvatar from "../userAvatar.js";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {Tabs, Tab} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import {ButtonGroup} from "@mui/material";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuList from "../../includes/menulist";
import MenuListHome from "../../includes/menuListHome";
import {styled} from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {EditText} from "react-edit-text"; // Import EditText component
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import {useEffect} from "react";
import {Card, Button, Grid, TextField} from "@mui/material";
import Modal from "@mui/material/Modal";
import Snackbar from "@mui/material/Snackbar";
import {updatePrivacy} from "../../apihelper/profile.js";

import Alert from "@mui/material/Alert";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import { getCryporCurrencyList } from "../../apihelper/cryptocurrencylist";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import {getsymbollink} from "../../apihelper/getsymbollink.js";
import CircularProgress from "@mui/material/CircularProgress";
import BarChartIcon from "@mui/icons-material/BarChart";
import {
    Dialog,
    DialogTitle,
    BottomNavigationAction,
    BottomNavigation,
    DialogContent,
    DialogActions,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {getPortfolioData, getmultiPortfolio} from "../../apihelper/portfolio";
import {addToPortfolio, RenamePortfolio, updateProfilePhoto} from "../../apihelper/portfolio";
import {useNavigate} from "react-router-dom";
import {Helmet} from "react-helmet";
import AddIcon from "@mui/icons-material/Add";
import Portfolioadd from "../addPage/portfolioadd";
import SidebarMenuList from "../../includes/sidebarMenuList";
import {getCryporCurrencyList, getTotalunit, getFetchdropdown} from "../../apihelper/cryptocurrencylist";
import "react-edit-text/dist/index.css";
import WatchListGallery from "../home/watchlistgallery.js";
import {useLocation} from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";

import {getCryporCurrencyListHome} from "../../apihelper/homepage";
import {tabLink} from "../../common/constant/tablink.jsx";
import BottomTab from "../../common/hooks/BottomTab.jsx";
import LoginPopUp from "../../common/alert/login/LoginPopUp.jsx";
const useStyles = styled((theme) => ({
    tableContainer: {
        maxWidth: 600,
        margin: "0 auto",
    },
    table: {
        display: "none", // Hide the table on all screens
        [theme.breakpoints.down("sm")]: {
            display: "table", // Show the table on small screens only (mobile view)
        },
    },
    cardContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            display: "none", // Hide the card container on small screens (mobile view)
        },
    },
    card: {
        width: "100%",
        margin: "8px",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "300px", // Adjust the card width as needed
        },
    },
}));

const drawerWidth = 292;
const existingOptions = [
    {value: "Category A", label: "Category A"},
    {value: "Category B", label: "Category B"},
    {value: "Category C", label: "Category C"},
];
const NewUserAudit = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [portfolioTypeId, setPortfolioTypeId] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null); // State to store selected file
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const handleLoginClick = () => {
        // Mask the URL by adding /login at the end without navigating
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        // Open the login modal
        setLoginModalOpen(true);
    };
    const handleModalClose = () => {
        // Close the modal and reset the URL to the welcome page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };
    const [isAtBottom, setIsAtBottom] = useState(false);

    const navigate = useNavigate();
    const {window1} = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);

    const [snackbaropen, setSnackbaropen] = useState(false);

    const classes = useStyles();
    const [alignment, setAlignment] = useState("left");
    const [loader, setLoader] = useState(false);
    const [slugdata, setSlugdata] = useState([]);
    const [index, setIndex] = useState(0);
    const [addMoreLoader, setAddMoreLoader] = useState(false);
    const [portfolioname, setPortfolioname] = useState("");
    const [filter, setFilter] = useState("");
    const [loaderbutton, setLoaderButton] = useState(true);
    const [roivalue, setRoivalue] = useState("--");
    const [portfoliovalue, setPortfoliovalue] = useState("--");
    const [lastUpdatedTime, setLastUpdatedTiem] = useState("");
    const [portfolioid, setportfolioid] = useState("");
    const [options, setOptions] = useState([]);
    const [dropDown, setdropDown] = useState([]);
    const [newOptionValue, setNewOptionValue] = useState("");
    const [selectedOption, setSelectedOption] = useState([]);
    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });

    const [msgAfterLoading, setMsgAfterLoading] = useState("");
    const [unit, setUnit] = useState("");
    const [buySell, setbuySell] = React.useState("");
    const [price, setPrice] = useState("");

    const [selectedDate, handleDateChange] = useState("");
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const [severity, setSeverity] = useState("info");
    const [initialPage, setInitialPage] = useState(false);
    const [localUserData, setLocalUserData] = useState(undefined);
    const [loaderForSymbolLink, setLoaderForSymbolLink] = useState(false);
    const [dataslug, setdataslug] = useState("");
    const [totalUnits, setTotalUnits] = useState(0);
    const [Usablewallet, setUsablewallet] = useState("");
    const [user_role, setuser_role] = useState("");
    const [openPopup, setOpenPopup] = useState(false);
    const location = useLocation();
    const loc = location.pathname;

    const [lockStatus, setLockStatus] = useState({});

    // // Retrieve saved lock state from localStorage when the component mounts
    // useEffect(() => {
    //   const savedLockStatus = JSON.parse(localStorage.getItem('lockStatus')) || {};
    //   setLockStatus(savedLockStatus);
    // }, []);

    const handleChange = async (selectedOption, slug) => {
        if (selectedOption && selectedOption._isNew_) {
            setIsDialogOpen(true);
            console.log("Creating new option:", selectedOption.value);
            setSelectedOption(null);
            setdataslug(slug);
        } else if (!selectedOption) {
            // Handle the case when the selection is cleared
            setSelectedOption(null);
            setShowAlert(false);
            // Perform any other necessary actions
            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option."); // Set error message
                setShowAlert(true); // Show the alert
                return; // Abort further processing
            }
            setShowAlert(false);
            setSelectedOption(selectedOption);
            const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
            getTotalunit({
                user_id: userData.user_id,
                slug: slug, // Assuming value contains the slug
                portfolio_type_id: selectedOption.value, // Adjust as needed
                Token: userData?.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.log("Data fething error");
                }
                // console.log(slugdata)
            });
        }
    };

    const handleCreate = async (inputValue) => {
        if (options.find((option) => option.value === inputValue)) {
            return; // Exit early if the option already exists
        }
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        //console.log(inputValue);
        const newOption = {value: inputValue, label: inputValue};
        const newOptions = [...options, newOption]; // Create a new array with the existing options plus the new one
        setOptions(newOptions); // Update the options state
        const createdOption = newOptions.find((option) => option.value == inputValue);
        // console.log(createdOption);
        if (createdOption) {
            handleChange(createdOption);
        }
    };

    const handleSymbolLink = (symbolName) => {
        //console.log(symbolName)
        setLoaderForSymbolLink(true);
        getsymbollink(symbolName).then((res) => {
            if (res.code === "200") window.open(res.article_link, "_blank", "noreferrer");
            // window.location.replace(res.article_link);
            // setLoaderForSymbolLink(false);
            setLoaderForSymbolLink(false);
        });
    };

    useEffect(() => {
        fetchDropdownOptions();
    }, []);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 600,
        })
    );
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 410,
        })
    );
    const mediaQueryVar3 = useMediaQuery(
        json2mq({
            maxWidth: 430,
        })
    );
    var rows = [],
        i = 0,
        len = 15;
    while (++i <= len) rows.push(i);
    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const resetSelectedFile = () => {
        setSelectedFile(null);
    };

    const [rowsToShow, setRowsToShow] = useState(7);

    // const loadMore = () => {
    //   // setLoader(false);
    //   setAddMoreLoader(true);
    //   setIndex(index + 10);
    //   //console.log(index);
    //   const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    //   getmultiPortfolio({
    //     slug: filter,
    //     user_id: userData.user_id,
    //     start_index: index + 10,
    //     limit: `${10}`,
    //     Token: userData.token,
    //   }).then((res) => {
    //     if (res.code === "200") {
    //       //console.log("data got successfully");
    //       setSlugdata([...slugdata, ...res.data]);
    //       //console.log(res.data);
    //       if (res.data.length < 10) {
    //         //console.log("change Loaderbutton");
    //         setLoaderButton(false);
    //       } else {
    //         setLoaderButton(true);
    //       }
    //       setLoader(true);
    //       setAddMoreLoader(false);
    //     } else {
    //       //console.log("Data fething error");
    //     }
    //     // console.log(slugdata)
    //   });
    // };
    const [isRowClicked, setIsRowClicked] = useState(false);

    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleChange2 = (e) => {
        const value = e.target.value;
        // Check if the input contains a hyphen
        if (value.includes("-")) {
            setShowAlert(true); // Show the alert if there's a hyphen
        } else {
            setShowAlert(false); // Hide the alert if there's no hyphen
            setNewOptionValue(value); // Update the state with the new value
        }
    };
    const handleDialogSubmit = () => {
        // Handle submitting the dialog (e.g., creating the new option)
        console.log("Creating new option:", newOptionValue);

        // Update options state with the new option
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions([...options, newOption]);
        setSelectedOption(newOption);
        // Close the dialog
        setIsDialogOpen(false);

        // setSelectedOption(selectedOption);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug, // Assuming value contains the slug
            portfolio_type_id: newOption.value, // Adjust as needed
            Token: userData?.token,
        }).then((res) => {
            if (res.code === "200") {
                setTotalUnits(res.total_uint);
                setNewOptionValue("");
                setUsablewallet(res.wallet_amount);
            } else {
                console.log("Data fething error");
            }
            // console.log(slugdata)
        });
    };

    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const container = window1 !== undefined ? () => window().document.body : undefined;

    // useEffect(() => {
    //   // Perform localStorage action
    //   const item = localStorage.getItem('userdata')
    //   if (item ==null){
    //      setredirectpage(true);
    //   }
    //   //console.log("tapan"+item);
    // }, [])
    // if (redirectpage) {

    //   return redirect('/');
    // }

    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            border: 0,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            border: 0,
        },
    }));

    const StyledTableRow = styled(TableRow)(({theme}) => ({
        // hide last border

        "& td, & th": {
            border: 0,
        },
    }));

    const [selectedButton, setSelectedButton] = useState("CoinPrices");
    const [isTableView, setIsTableView] = useState(true);
    const handleButtonClick = (buttonName) => {
        // If the same button is clicked again, don't toggle the view
        if (selectedButton === buttonName) {
            return;
        }

        // Toggle the view based on the clicked button
        setSelectedButton(buttonName);
        setIsTableView(buttonName === "CoinPrices" ? false : true); // Show table view only if 'CoinPrices' is selected
    };

    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [sortOrder, setSortOrder] = useState({
        // Track ascending/descending for each column
        roi: "asc",
        profit: "asc",
    });
    const [sortType, setSortType] = useState("roi_asc");

    const handleSort = (column) => {
        console.log("Arrow Clicked");
        const newSortOrder = sortOrder[column] === "asc" ? "desc" : "asc"; // Toggle sort order
        setSortOrder({...sortOrder, [column]: newSortOrder});

        console.log("Sorted");

        // Set the sort type based on the column
        switch (column) {
            case "roi":
                setSortType(newSortOrder === "asc" ? "roi_asc" : "roi_desc");
                break;

            case "profit":
                setSortType(newSortOrder === "asc" ? "profit_asc" : "profit_desc");
                break;

            default:
                break;
        }
    };

    //console.log("Data : ", data);
    // Helper function to convert net profit to a number
    const convertNetProfit = (profit) => {
        const number = parseFloat(profit.replace(/[^0-9.-]+/g, "")); // Remove $ sign and commas
        return isNaN(number) ? 0 : number; // Handle invalid or empty values
    };

    const filteredData = data.filter(
        (portfolio) =>
            portfolio.total_net_profit !== null &&
            portfolio.total_net_profit !== undefined &&
            !isNaN(convertNetProfit(portfolio.total_net_profit))
    );

    //console.log("Filtered Data: ", filteredData);

    // Helper function to convert ROI value to a number
    const convertRoiValue = (roi) => {
        const number = parseFloat(roi.replace("%", ""));
        return isNaN(number) ? 0 : number; // Handle invalid or empty values
    };

    const sortedData = [...filteredData].sort((a, b) => {
        switch (sortType) {
            case "roi_asc":
                return convertRoiValue(a.roi_value) - convertRoiValue(b.roi_value);
            case "roi_desc":
                return convertRoiValue(b.roi_value) - convertRoiValue(a.roi_value);

            case "profit_asc":
                return convertNetProfit(a.total_net_profit) - convertNetProfit(b.total_net_profit);
            case "profit_desc":
                return convertNetProfit(b.total_net_profit) - convertNetProfit(a.total_net_profit);

            default:
                return 0;
        }
    });

    const [showModal, setShowModal] = useState(false); // Change the state name to showModal

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setIndex(0);
            setLoader(false);

            getCryporCurrencyListHome({
                slug: filter,
                start_index: 0,
                limit: "20",
                category: "",
                hashtagdata: "",
                selected_filters: [],
                volume: [],
                marketCap: [],
                sentiment_filters: [],
                user_id: userData?.user_id,
                pathname: "audit-my-portfolio",
            }).then((res) => {
                if (res.code === "200") {
                    setSlugdata(res.data);
                    setuser_role(res.user_role);
                    setLastUpdatedTiem(res.current_price_updated_on);
                    setLoaderButton(res.data.length >= 20);
                    setLoader(true);
                    setAddMoreLoader(false);
                } else {
                    console.log("Data fetching error");
                }
            });
        }, 300); // <-- Debounce delay: 500ms

        return () => clearTimeout(delayDebounce); // Cleanup previous timeout
    }, [filter]);

    const observerRef = useRef(null);

    const loadMore = () => {
        if (addMoreLoader) return;

        setAddMoreLoader(true);
        setIndex(index + 20);

        getCryporCurrencyListHome({
            slug: filter,
            start_index: index + 20,
            limit: `${20}`,
            category: "",
            hashtagdata: "",
            selected_filters: [],
            volume: [],
            marketCap: [],
            sentiment_filters: [],
            user_id: userData?.user_id,
            pathname: "audit-my-portfolio",
        }).then((res) => {
            if (res.code === "200") {
                console.log("data got successfully");
                setSlugdata([...slugdata, ...res.data]);

                if (res.data.length < 20) {
                    //console.log("change Loaderbutton");
                    setLoaderButton(false);
                } else {
                    setLoaderButton(true);
                }
                setLoader(true);
                setAddMoreLoader(false);
            } else {
                console.log("Data fething error");
            }
            // console.log(slugdata)
        });
    };

    useEffect(() => {
        console.log("calling");

        if (!loaderbutton || addMoreLoader) return; // Avoid unnecessary calls

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    console.log("Bottom reached! Loading more...");
                    loadMore();
                }
            },
            {rootMargin: "100px", threshold: 0.1}
        );

        const currentRef = observerRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
            observer.disconnect(); // Proper cleanup
        };
    }, [loaderbutton, addMoreLoader, loadMore]);

    const slugdata1 = slugdata.slice();

    const sortedSlugdata = slugdata1;
    const handleAddToPortfolio = (idx) => {
        console.log("IDX value is : ", idx);

        // Check if userData exists before making the API call
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        if (!userData) {
            const originalUrl = "/audit-my-portfolio";
            sessionStorage.setItem("originalUrl", originalUrl);
            console.log("original url: " + originalUrl);
            window.history.pushState({}, "", "/login");
            setLoginModalOpen(true);
            return; // Exit the function if userData is not present
        }

        console.log("User Data is there");

        // If userData exists, proceed with fetching cryptocurrency data
        getCryporCurrencyListHome({
            slug: idx,
            user_id: userData?.user_id,
            pathname: "audit-my-portfolio",
            start_index: 0,
            limit: "20",
        }).then((res) => {
            if (res.code === "200") {
                console.log("data got successfully", res.data);

                // Update slugdata
                setuser_role(res.user_role);

                // Use res.data directly here
                setSlugpopupdata({
                    slugname: res.data[0].slug,
                    slug: res.data[0].name,
                    units: res.data[0].total_unit,
                    pricetoday: res.data[0].price_today,
                    logo: res.data[0].logo,
                });
                console.log("Slug Popup Data : ", res.data);
                setOpen(true);
            } else {
                console.log("Data fetching error");
            }
        });
    };

    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        setIsFormSubmitted(false);
        // setSnackbarcolor("success");
        // setSnackbarmessage("Data saved successfully");
        setMsgforUpdatePortfolio("loading...");
        //console.log(price, selectedDate, buySell, unit);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const portfolioId =
            selectedOption && !isNaN(parseInt(selectedOption.value)) ? parseInt(selectedOption.value) : 0;
        const existingPortfolio = portfolioId > 0 ? "yes" : "no"; // Determine existing_portfolio based on portfolioId

        addToPortfolio({
            portfolio_type_id: portfolioId,
            portfolio_name: selectedOption ? selectedOption.label : "", // Ensure selectedOption is defined

            existing_portfolio: existingPortfolio,
            user_id: userData.user_id,
            slug: slugpopupdata.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData?.token,
        }).then((res) => {
            if (res.code === "200") {
                // setOpen(false);
                setSeverity("info");
                //console.log(res.message);
                setMsgforUpdatePortfolio(res.message);
                setPortfolioTypeId(res.portfolio_type_id);
                setIsFormSubmitted(true);
                // navigate(
                //   `/my-portfolio/${res.portfolio_type_id}/${encodeURIComponent(
                //     selectedOption.label
                //   )}`
                // );
            } else {
                setSeverity("error");
                // setOpen(true)
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };
    const fetchDropdownOptions = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

        // Run the function only if userData exists and has user_id and token
        if (!userData || !userData.user_id || !userData.token) {
            console.log("User data is missing. Skipping fetchDropdownOptions.");
            return;
        }

        getFetchdropdown({
            user_id: userData.user_id,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                const newOptions = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));

                setOptions(newOptions);
                setuser_role(res.user_role);

                // Set the last option as the default selected option
                if (newOptions.length > 0) {
                    setSelectedOption(newOptions[newOptions.length - 1]);
                    handleChange(newOptions[newOptions.length - 1], slugpopupdata.slugname);
                }
            } else {
                console.log("Data fetching error");
            }
        });
    };

    const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);

    const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: "4px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[
                            tabLink["portfolio_audit"],
                            userData ? tabLink["my_portfolio"] : tabLink["top_portfolio"],
                            tabLink["screener"],
                        ].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {!mediaQueryVar ? tab.mobile_name : tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };
    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["portfolio_audit"], tabLink["screener"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const SkeletonLoader = () =>
        Array.from({length: 6}).map((_, index) => (
            <tr
                key={index}
                style={{
                    background: "#fff",
                    border: "1px solid #1877F2",
                    borderRadius: "10px",
                    marginBottom: "10px",
                    padding: "6px",
                    height: "60px",
                }}
            >
                {Array.from({length: 6}).map((_, idx) => (
                    <td
                        key={idx}
                        style={{
                            padding: "12px",
                            textAlign: "center",
                            fontSize: "14px",
                            border: "1px solid #1877F2",
                            borderRadius: idx === 0 ? "20px 0 0 20px" : idx === 5 ? "0 20px 20px 0" : "0",
                            borderLeft: idx === 0 ? "none" : "",
                            borderRight: idx === 4 ? "none" : "",
                        }}
                    >
                        <div className="skeleton-box" />
                    </td>
                ))}
            </tr>
        ));

    return (
        <>
            {mediaQueryVar === true ? (
                <Box
                    sx={{
                        display: "flex",

                        flexDirection: mediaQueryVar === false ? "column" : "",
                        minHeight: "100vh",
                        // overflow: 'hidden',
                    }}
                    className="maindiv"
                >
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: drawerWidth,
                            width: `calc(100% - ${drawerWidth}px)`,
                            backgroundColor: "#ffffff",
                            zIndex: 1000,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            height: "100px", // You may need to increase this if banner + nav exceeds 100px
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <PromoBanner />
                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                    </div>

                    <Helmet>
                        <title>Audit My Portfolio</title>
                    </Helmet>
                    <CssBaseline />
                    <div className="windowheader">
                        <AppBar
                            position="fixed"
                            sx={{
                                width: {sm: `calc(100% - ${drawerWidth}px)`},
                                ml: {sm: `${drawerWidth}px`},
                            }}
                            style={{
                                backgroundColor: "white",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    sx={{mr: 2, display: {sm: "none"}}}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <img
                                    src={window.constants.asset_path + "/images/logo_with_bg.png"}
                                    width={220}
                                    height={50}
                                    alt="CWLOGO"
                                    style={{margin: "10px", borderRadius: "5px"}}
                                />
                            </Toolbar>
                        </AppBar>
                    </div>
                    <Box
                        component="nav"
                        sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                        aria-label="mailbox folders"
                    >
                        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{
                                display: {xs: "block", sm: "none"},
                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                        >
                            {drawer}
                        </Drawer>
                        <Drawer
                            variant="permanent"
                            sx={{
                                display: {xs: "none", sm: "block"},
                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                            open
                        >
                            {drawer}
                        </Drawer>
                    </Box>

                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: 3,
                            width: {sm: `calc(100% - ${drawerWidth}px)`},
                            padding: "5px",
                            backgroundColor: "#EDF1F6",
                        }}
                    >
                        {initialPage && <Portfolioadd />}
                        {!initialPage && (
                            <>
                                <div className="windowheader">
                                    <Toolbar />
                                </div>
                                <Box sx={{flexGrow: 1}} style={{marginBottom: "15px", marginTop: "170px"}}>
                                    <Box
                                        sx={{
                                            margin: "10px",
                                            marginLeft: "15px",
                                            marginRight: "5px",
                                            overflow: "auto",
                                            // Hide the scrollbar
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                            "-ms-overflow-style": "none",
                                            "scrollbar-width": "none",
                                        }}
                                    >
                                        {selectedButton === "CoinPrices" && (
                                            <>
                                                <TableContainer
                                                    style={{
                                                        overflowX: "auto",
                                                        borderRadius: "5px",
                                                        margin: "0 auto",
                                                        width: "100%",
                                                        paddingRight: "20px",
                                                    }}
                                                >
                                                    <Table
                                                        className="non_responsiveTable"
                                                        aria-label="customized table"
                                                        style={{borderCollapse: "collapse", width: "100%"}}
                                                    >
                                                        <TableBody>
                                                            <StyledTableRow>
                                                                {/* Other table cells */}

                                                                {/* If you want to add a centered button in the last row */}
                                                                <TableCell colSpan={4} style={{textAlign: "center"}}>
                                                                    {!userData ? (
                                                                        <div>
                                                                            <div
                                                                                style={{
                                                                                    padding: "15px 20px",
                                                                                    borderRadius: "8px",
                                                                                    background:
                                                                                        "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                                                                    fontSize: "16px",
                                                                                    fontWeight: "500",
                                                                                    textAlign: "left",
                                                                                    lineHeight: "1.5",
                                                                                    color: "#000",
                                                                                    marginBottom: "15px",
                                                                                }}
                                                                            >
                                                                                <h4
                                                                                    style={{
                                                                                        marginTop: "0",
                                                                                        marginBottom: "20px",
                                                                                        fontWeight: "700",
                                                                                        fontSize: "20px",
                                                                                    }}
                                                                                >
                                                                                    How to Audit Your Crypto Portfolio
                                                                                </h4>
                                                                                <ul
                                                                                    style={{
                                                                                        paddingLeft: "20px",
                                                                                        margin: "0",
                                                                                    }}
                                                                                >
                                                                                    <li>
                                                                                        Click on any cryptocurrency to
                                                                                        add; a pop-up will appear.
                                                                                    </li>
                                                                                    <li>
                                                                                        Use the pop-up to create new
                                                                                        portfolio and add
                                                                                        cryptocurrencies.
                                                                                    </li>
                                                                                    <li>
                                                                                        Once complete, access the
                                                                                        portfolio, click "Analysis" and
                                                                                        "Recommendations" for portfolio
                                                                                        analysis and suggestions.
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            <button
                                                                                onClick={() => {
                                                                                    const originalUrl =
                                                                                        "/audit-my-portfolio";
                                                                                    sessionStorage.setItem(
                                                                                        "originalUrl",
                                                                                        originalUrl
                                                                                    );
                                                                                    console.log(
                                                                                        "original url: " + originalUrl
                                                                                    );
                                                                                    handleLoginClick();
                                                                                }}
                                                                                style={{
                                                                                    border: "1px solid #1877F2",
                                                                                    borderRadius: "48px",
                                                                                    padding: "15px 36px",
                                                                                    backgroundColor: "white",
                                                                                    color: "#1877F2",
                                                                                    fontSize: "24px",
                                                                                    height: "66px",
                                                                                    marginRight: "8px",
                                                                                    fontWeight: "500",
                                                                                    margin: "20px",
                                                                                    marginTop: 0,
                                                                                }}
                                                                            >
                                                                                Audit My Portfolio
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                padding: "15px 20px",
                                                                                borderRadius: "8px",
                                                                                background:
                                                                                    "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                                                                fontSize: "16px",
                                                                                fontWeight: "500",
                                                                                textAlign: "left",
                                                                                lineHeight: "1.5",
                                                                                color: "#000",
                                                                                marginBottom: "15px",
                                                                            }}
                                                                        >
                                                                            <h4
                                                                                style={{
                                                                                    marginTop: "0",
                                                                                    marginBottom: "20px",
                                                                                    fontWeight: "700",
                                                                                    fontSize: "20px",
                                                                                }}
                                                                            >
                                                                                How to Audit Your Crypto Portfolio
                                                                            </h4>
                                                                            <ul
                                                                                style={{
                                                                                    paddingLeft: "20px",
                                                                                    margin: "0",
                                                                                }}
                                                                            >
                                                                                <li>
                                                                                    Click on any cryptocurrency to add;
                                                                                    a pop-up will appear.
                                                                                </li>
                                                                                <li>
                                                                                    Use the pop-up to create new
                                                                                    portfolio and add cryptocurrencies.
                                                                                </li>
                                                                                <li>
                                                                                    Once complete, access the portfolio,
                                                                                    click "Analysis" and
                                                                                    "Recommendations" for portfolio
                                                                                    analysis and suggestions.
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    )}
                                                                </TableCell>
                                                            </StyledTableRow>
                                                        </TableBody>
                                                    </Table>
                                                    <div
                                                        style={{
                                                            border: "1px solid #EEE",
                                                            borderRadius: "5px",
                                                            overflow: "hidden",
                                                            width: "300px",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                        }}
                                                    >
                                                        {selectedButton == "CoinPrices" && (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                md={3}
                                                                sx={{
                                                                    marginBottom: "15px",
                                                                }}
                                                            >
                                                                <TextField
                                                                    style={{
                                                                        width: "100%",
                                                                        borderRadius: "46px",
                                                                        marginTop:
                                                                            mediaQueryVar === true ? "10px" : "90px",
                                                                        fontFamily: "Satoshi, sans-serif",
                                                                        borderRadius: "46px",
                                                                        border: " 1px #1877F2 solid",
                                                                        backgroundColor: "#fff",
                                                                        paddingTop: "2px",
                                                                        paddingBottom: "2px",
                                                                        paddingLeft: "12px",
                                                                        paddingRight: "30px",
                                                                        fontSize: "16px",
                                                                        fontWeight: "500",
                                                                        color: "#1877F2",
                                                                    }}
                                                                    className="cryptocurrencyListHeaderSearch"
                                                                    size="small"
                                                                    placeholder="Search Cryptos to add"
                                                                    onInput={(e) => setFilter(e.target.value)}
                                                                    value={filter}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <img src="images/search.svg" />
                                                                            </InputAdornment>
                                                                        ),
                                                                        style: {
                                                                            border: "none", // Remove the border from the input
                                                                        },
                                                                    }}
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                borderColor: "transparent", // Remove the border of the fieldset
                                                                            },
                                                                            "&:hover fieldset": {
                                                                                borderColor: "transparent", // Remove the border on hover
                                                                            },
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: "transparent", // Remove the border when focused
                                                                            },
                                                                            "& input::placeholder": {
                                                                                color: "#1877F2",
                                                                                opacity: 1,
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            margin: 0,
                                                            fontFamily: "Arial, sans-serif",
                                                            overflowX: "auto",
                                                            marginTop: "0px",
                                                        }}
                                                    >
                                                        <style>
                                                            {`
                                        @keyframes shimmer {
                                          0% { background-position: -200px 0; }
                                          100% { background-position: 200px 0; }
                                        }
                                        .skeleton-box {
                                          width: 80%;
                                          height: 20px;
                                          background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
                                          background-size: 200px 100%;
                                          border-radius: 4px;
                                          animation: shimmer 1.2s infinite linear;
                                        }
                                      `}
                                                        </style>
                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "separate",
                                                                borderSpacing: "0 12px",
                                                            }}
                                                        >
                                                            <thead>
                                                                <tr
                                                                    style={{
                                                                        background:
                                                                            "linear-gradient(180deg, rgba(24, 119, 242, 0.11) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                                                        color: "#333",
                                                                        border: "5px solid #1877F2",
                                                                        fontWeight: "bold",
                                                                        fontSize: "14px",
                                                                        textAlign: "left",
                                                                    }}
                                                                >
                                                                    <th
                                                                        style={{
                                                                            padding: "12px 16px",
                                                                            borderRadius: "10px 0 0 10px",
                                                                            width: "10%",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Crypto
                                                                    </th>
                                                                    {!loader ? (
                                                                        <>
                                                                            <th
                                                                                style={{
                                                                                    padding: "12px 16px",
                                                                                    width: "30%",
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                            ></th>
                                                                            <th
                                                                                style={{
                                                                                    padding: "12px 16px",
                                                                                    width: "20%",
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                            ></th>
                                                                        </>
                                                                    ) : null}

                                                                    <th
                                                                        style={{
                                                                            padding: "12px",
                                                                            textAlign: "center",
                                                                            width: "10%",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Price
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            padding: "12px",
                                                                            borderRadius: "0 10px 10px 0",
                                                                            width: "30%",
                                                                            fontWeight: "bold",
                                                                            paddingLeft: "5%",
                                                                        }}
                                                                    ></th>
                                                                </tr>
                                                                {/* Extra tr for blue line */}
                                                                <tr style={{marginTop: "-10px"}}>
                                                                    <th
                                                                        colSpan="5"
                                                                        style={{
                                                                            padding: "0",
                                                                            height: "5px",
                                                                            backgroundColor: "#1877F2",
                                                                            marginTop: "-10px",
                                                                        }}
                                                                    ></th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {!loader ? (
                                                                    <SkeletonLoader />
                                                                ) : sortedSlugdata.length == 0 ? (
                                                                    <tr>
                                                                        <td
                                                                            colSpan="6"
                                                                            style={{
                                                                                textAlign: "center",
                                                                                padding: "20px",
                                                                                fontSize: "16px",
                                                                                fontWeight: "bold",
                                                                                border: "2px solid #1877F2",
                                                                                borderRadius: "10px",
                                                                                background: "#f8f9fa",
                                                                                color: "#1877F2",
                                                                            }}
                                                                        >
                                                                            No Crypto Found
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    sortedSlugdata.map((coin, index) => (
                                                                        <tr
                                                                            key={index}
                                                                            style={{
                                                                                background: "#fff",
                                                                                border: "1px solid #1877F2",
                                                                                borderRadius: "10px",
                                                                                marginBottom: "10px",
                                                                                padding: "6px",
                                                                                height: "60px",
                                                                            }}
                                                                        >
                                                                            <td
                                                                                style={{
                                                                                    padding: "12px",
                                                                                    textAlign: "center",
                                                                                    fontSize: "14px",
                                                                                    border: "1px solid #1877F2",
                                                                                    borderTopLeftRadius: "20px",
                                                                                    borderBottomLeftRadius: "20px",
                                                                                    borderRight: "none",
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: "10px",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            padding: "12px 10px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            fontWeight: "bold",
                                                                                            fontSize: "15px",
                                                                                            color: "#000",
                                                                                            borderRadius: "10px",
                                                                                            minWidth: "220px",
                                                                                            maxWidth: "220px",

                                                                                            background:
                                                                                                "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                                                            boxShadow:
                                                                                                "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={coin.logo}
                                                                                            alt={coin.name}
                                                                                            style={{
                                                                                                width: "28px",
                                                                                                height: "28px",
                                                                                                borderRadius: "50%",
                                                                                                marginRight: "10px",
                                                                                            }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                flexWrap: "wrap",
                                                                                                wordBreak: "break-word",
                                                                                                overflowWrap:
                                                                                                    "break-word",
                                                                                            }}
                                                                                        >
                                                                                            {coin.name}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div
                                                                                        style={{
                                                                                            border: "2px solid #1877F2",
                                                                                            fontSize: "13px",
                                                                                            borderRadius: "20px",
                                                                                            padding: "3px 10px",
                                                                                            color: "#1877F2",
                                                                                            minWidth: "80px",
                                                                                            boxShadow:
                                                                                                " 0px 2px 2px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                                                        }}
                                                                                    >
                                                                                        {coin.category}
                                                                                    </div>
                                                                                </div>
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    padding: "12px",
                                                                                    textAlign: "center",
                                                                                    fontSize: "14px",
                                                                                    border: "1px solid #1877F2",
                                                                                    borderLeft: "none",
                                                                                    borderRight: "none",
                                                                                }}
                                                                            >
                                                                                {coin.price_today}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    padding: "12px",
                                                                                    textAlign: "center",
                                                                                    fontSize: "14px",
                                                                                    border: "1px solid #1877F2",
                                                                                    borderTopRightRadius: "20px",
                                                                                    borderBottomRightRadius: "20px",
                                                                                    borderLeft: "none",
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: "15px",
                                                                                        justifyContent: "flex-end",
                                                                                        marginRight: "30px",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        onClick={() =>
                                                                                            handleAddToPortfolio(
                                                                                                coin.slug
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            border: "2px solid #1877F2",
                                                                                            fontSize: "14px",
                                                                                            background:
                                                                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.20) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                                                                            borderRadius: "20px",
                                                                                            boxShadow:
                                                                                                " 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                                                            padding: "6px 18px",
                                                                                            color: "#1877F2",
                                                                                            fontWeight: "700",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                    >
                                                                                        Add to Portfolio
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </TableContainer>
                                                <div style={{position: "relative", marginTop: "50px"}}>
                                                    {addMoreLoader && (
                                                        <div
                                                            style={{
                                                                position: "absolute", // Keeps it inside the content area
                                                                bottom: "0px", // Always at the bottom of the content
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                padding: "10px",
                                                                borderRadius: "10px",
                                                                zIndex: 999, // Ensures visibility
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    border: "4px solid rgba(67, 97, 238, 0.3)", // Light blue border
                                                                    borderTop: "4px solid #4361ee", // Dark blue spinning part
                                                                    borderRadius: "50%",
                                                                    animation: "spin 1s linear infinite",
                                                                }}
                                                            ></div>
                                                        </div>
                                                    )}

                                                    <div
                                                        ref={observerRef}
                                                        style={{height: "20px", marginBottom: "50px"}}
                                                    ></div>

                                                    <style>
                                                        {`
                                    @keyframes spin {
                                        0% { transform: rotate(0deg); }
                                        100% { transform: rotate(360deg); }
                                    }
                                    `}
                                                    </style>
                                                </div>
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            </>
                        )}
                        {loaderForSymbolLink === true && (
                            <div>
                                <CircularProgress style={{position: "fixed", top: "40vh", left: "45vw"}} />
                            </div>
                        )}

                        <Modal
                            sx={{overflow: "hidden"}}
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <div className="CardOpener" style={{overflow: "hidden"}}>
                                {isFormSubmitted ? (
                                    <Card className="card__container">
                                        <>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <CheckCircleOutlineIcon sx={{fontSize: 50, mr: 1}} />
                                            </div>
                                            <Typography
                                                severity="success"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                Portfolio added successfully!
                                            </Typography>
                                        </>
                                        <div style={{display: "flex", justifyContent: "space-evenly"}}>
                                            <Button
                                                onClick={() => {
                                                    setIsFormSubmitted(false);
                                                    setOpen(false);
                                                    setUnit("");
                                                    setSelectedOption("");
                                                    setPrice("");
                                                    setTotalUnits(0);
                                                    handleDateChange("");
                                                    setUsablewallet("");
                                                }}
                                                color="primary"
                                                style={{
                                                    backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                    borderRadius: "6px",
                                                    border: "none",
                                                    textTransform: "none",
                                                    borderStyle: "solid",
                                                    borderColor: "rgba(67, 97, 238, 0.15)",
                                                    borderWidth: "1px",
                                                    color: "#4361ee",
                                                    whiteSpace: "nowrap",
                                                    float: "inline-end",
                                                    width: mediaQueryVar === true ? "150px" : "100px",
                                                    height: mediaQueryVar === false ? "30px" : "",
                                                    fontSize: mediaQueryVar === false ? "10px" : "11px",
                                                }}
                                            >
                                                Add More Cryptos
                                            </Button>
                                            <Button
                                                onClick={() =>
                                                    navigate(
                                                        `/my-portfolio/${portfolioTypeId}/${encodeURIComponent(
                                                            selectedOption.label.replace(/\s+/g, "-")
                                                        )}`
                                                    )
                                                }
                                                variant="outlined"
                                                style={{
                                                    backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                    borderRadius: "6px",
                                                    border: "none",
                                                    textTransform: "none",
                                                    borderStyle: "solid",
                                                    borderColor: "rgba(67, 97, 238, 0.15)",
                                                    borderWidth: "1px",
                                                    color: "#4361ee",
                                                    whiteSpace: "nowrap",
                                                    float: "inline-end",
                                                    width: mediaQueryVar === true ? "100px" : "100px",
                                                    height: mediaQueryVar === false ? "30px" : "",
                                                    fontSize: mediaQueryVar === false ? "10px" : "11px",
                                                }}
                                                color="primary"
                                            >
                                                View Portfolio
                                            </Button>
                                        </div>
                                    </Card>
                                ) : (
                                    <Dialog
                                        PaperProps={{
                                            sx: {
                                                position: mediaQueryVar ? "static" : "fixed",
                                                bottom: mediaQueryVar ? "" : 0,
                                                left: mediaQueryVar ? "" : 0,
                                                right: mediaQueryVar ? "" : 0,
                                                marginTop: "1%",
                                                maxWidth: "100%",
                                                minHeight: "60%", // Adjust max height if needed
                                                borderRadius: mediaQueryVar ? "24px" : "24px 24px 0 0",
                                                padding: "10px",
                                                alignItems: "center",
                                                overflow: "scroll",
                                                "&::-webkit-scrollbar": {
                                                    display: "none",
                                                },
                                                "-ms-overflow-style": "none",
                                                "scrollbar-width": "none", // Ensure no scrollbar
                                            },
                                        }}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <div style={{padding: "20px", width: "400px", margin: "0", marginTop: "-5px"}}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "20px",
                                                    borderBottom: "1px #E3E3E3 solid",
                                                }}
                                            >
                                                <Typography
                                                    style={{
                                                        fontWeight: "500",
                                                        fontSize: "20.767px",
                                                        paddingLeft: "100px",
                                                    }}
                                                    gutterBottom
                                                >
                                                    Add To Portfolio
                                                </Typography>

                                                <div className="primaryButton">
                                                    <img
                                                        className="frameIcon"
                                                        alt=""
                                                        onClick={handleClose}
                                                        src={window.constants.asset_path + "/images/frame17.svg"}
                                                        style={{background: "#F3F3F3", width: "25px", height: "25px"}}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    marginBottom: "5px",
                                                    marginLeft: mediaQueryVar === false ? "10px" : "",
                                                }}
                                            >
                                                <Typography
                                                    style={{
                                                        fontSize: "13.845px",
                                                        fontWeight: "500",
                                                        marginBottom: "1px",
                                                        color: "black",
                                                        marginTop: "-8px",
                                                    }}
                                                >
                                                    Select Portfolio
                                                </Typography>
                                                <div style={{marginTop: "5px"}}>
                                                    <CreatableSelect
                                                        isClearable
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                borderRadius: "12px",
                                                                border: "1px solid #1877F2",
                                                                boxShadow: "none",
                                                                minHeight: "40px",
                                                                "&:hover": {
                                                                    borderRadius: "12px",
                                                                    border: "2px solid #1877F2",
                                                                },
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                borderRadius: "8px",
                                                            }),
                                                            placeholder: (provided) => ({
                                                                ...provided,
                                                                color: "",
                                                            }),
                                                            dropdownIndicator: (provided) => ({
                                                                ...provided,
                                                                color: "#1877F2",
                                                                border: "1px solid #1877F2",
                                                                padding: "5px",
                                                                margin: "8px",
                                                                borderRadius: "3.786px",
                                                                "&:hover": {
                                                                    color: "#1877F2",
                                                                },
                                                            }),
                                                            indicatorSeparator: (provided) => ({
                                                                display: "none",
                                                            }),
                                                        }}
                                                        placeholder=""
                                                        onChange={(options) =>
                                                            handleChange(options, slugpopupdata.slugname)
                                                        }
                                                        onCreateOption={handleCreate}
                                                        options={[
                                                            {value: "", label: "Create new portfolio", _isNew_: true}, // Dynamic "create new option" item
                                                            ...options, // Existing options
                                                        ]}
                                                        value={selectedOption}
                                                    />
                                                </div>
                                                {showAlert && (
                                                    <Alert severity="error" sx={{marginBottom: "10px"}}>
                                                        {errorMessage}
                                                    </Alert>
                                                )}
                                            </div>
                                            <Typography
                                                style={{
                                                    fontSize: "13.845px",
                                                    fontWeight: "500",
                                                    color: "#000",
                                                    marginTop: "10px",
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                Usable Wallet Value: {Usablewallet}
                                            </Typography>
                                            <div
                                                style={{
                                                    padding: "8px",
                                                    background: "#F3F3F3",
                                                    borderRadius: "8px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    marginBottom: "5px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flex: 0,
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            marginRight: "10px",
                                                            border: "2px solid #000",
                                                            borderRadius: "19px",
                                                            height: "27.69px",
                                                            width: "27.69px",
                                                        }}
                                                        alt=""
                                                        src={slugpopupdata.logo}
                                                    />
                                                    <div style={{display: "flex", flexDirection: "column"}}>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: "500",
                                                                marginBottom: "4px",
                                                                fontSize: "14px",
                                                                color: "#7F7F80",
                                                            }}
                                                        >
                                                            {slugpopupdata.slugname}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        marginLeft: "23%",
                                                        flex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            marginBottom: "4px",
                                                            fontSize: "13px",
                                                            color: "#7F7F80",
                                                        }}
                                                    >
                                                        {" "}
                                                        Price
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "12.114px",
                                                            fontWeight: "500",
                                                            color: "black",
                                                            margin: "0",
                                                            marginLeft: "15px",
                                                        }}
                                                    >
                                                        {slugpopupdata.pricetoday}
                                                    </Typography>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        marginLeft: "20px",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            marginBottom: "4px",
                                                            fontSize: "13px",
                                                            color: "#7F7F80",
                                                        }}
                                                    >
                                                        {" "}
                                                        Units
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "12.114px",
                                                            fontWeight: "500",
                                                            color: "black",
                                                            margin: "0",
                                                        }}
                                                    >
                                                        {totalUnits}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div className="card__container__row3">
                                                <div style={{marginLeft: "-5px"}}>
                                                    <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                        Enter number of Units
                                                    </p>
                                                    <input
                                                        style={{
                                                            backgroundColor: "white",
                                                            color: "black",
                                                            padding: "20px",
                                                            border: "1px solid #1877F2",
                                                            borderRadius: "10.384px",
                                                            width: "350px",
                                                            height: "45px",
                                                            margin: 0,
                                                        }}
                                                        min="1"
                                                        max="10"
                                                        type="number"
                                                        placeholder=""
                                                        value={unit}
                                                        onChange={(e) => setUnit(e.target.value)}
                                                    ></input>
                                                </div>
                                                <div>
                                                    $
                                                    {formatToNonZero(
                                                        unit *
                                                            parseFloat(
                                                                (slugpopupdata.pricetoday || "").replace(/^\$/, "")
                                                            )
                                                    )}
                                                </div>
                                                {user_role === "superuser" && (
                                                    <>
                                                        <div className="card__container__row3__r2">
                                                            <div style={{marginLeft: "-5px"}}>
                                                                <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                                    Buy/Sell Price($)
                                                                </p>
                                                                <input
                                                                    style={{
                                                                        backgroundColor: "white",
                                                                        color: "black",
                                                                        padding: "20px",
                                                                        border: "1px solid #1877F2",
                                                                        borderRadius: "10.384px",
                                                                        width: "345px",
                                                                        height: "45px",
                                                                    }}
                                                                    className="card__container__row3__r2__input"
                                                                    min="1"
                                                                    max="10"
                                                                    type="number"
                                                                    placeholder="Enter Price"
                                                                    value={price}
                                                                    onChange={(e) => setPrice(e.target.value)}
                                                                ></input>
                                                            </div>
                                                        </div>
                                                        <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                                            <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                                            <TextField
                                                                type="date"
                                                                value={selectedDate}
                                                                onChange={(e) => handleDateChange(e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        borderRadius: "10.384px",
                                                                        border: "1px solid #1877F2",
                                                                        boxShadow: "none",
                                                                        width: "190%",
                                                                        height: "45px",
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                <div className="card__container__row3__r4" style={{marginTop: "10px"}}>
                                                    <Button
                                                        className={
                                                            buySell === "buy"
                                                                ? "buttonToggleButActive"
                                                                : "buttonToggleBuy"
                                                        }
                                                        value="Buy"
                                                        style={{
                                                            lineHeight: "20px",
                                                            width: "159px",
                                                            borderRadius: "27px",
                                                            border: "1px solid #1877F2",
                                                            padding: "15px 85px",
                                                            marginLeft: "-10px",
                                                            backgroundColor: buySell === "buy" ? "" : "#1877F2",
                                                            color: buySell === "buy" ? "" : "white",
                                                            textTransform: "none",
                                                            fontSize: "18px",
                                                            fontWeight: "700",
                                                        }}
                                                        onClick={() => handleClick("buy")}
                                                    >
                                                        Add
                                                    </Button>
                                                    <Button
                                                        className={
                                                            buySell === "sell"
                                                                ? "buttonToggleSellActive"
                                                                : "buttonToggleSell"
                                                        }
                                                        value="sell"
                                                        style={{
                                                            lineHeight: "20px",
                                                            width: "159px",
                                                            borderRadius: "27px",
                                                            border: "1px solid #1877F2",
                                                            marginLeft: "10px",
                                                            padding: "15px 85px",
                                                            backgroundColor: buySell === "sell" ? "" : "#1877F2",
                                                            color: buySell === "sell" ? "" : "white",
                                                            textTransform: "none",
                                                            fontSize: "18px",
                                                            fontWeight: "700",
                                                        }}
                                                        onClick={() => handleClick("sell")}
                                                    >
                                                        Remove
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog>
                                )}
                            </div>
                        </Modal>

                        <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                            <DialogTitle>
                                Create New Portfolio
                                <IconButton
                                    aria-label="close"
                                    onClick={() => {
                                        setIsDialogOpen(false);
                                        setNewOptionValue("");
                                    }}
                                    sx={{position: "absolute", right: 13, top: 8}}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <div>
                                    <TextField
                                        autoFocus
                                        label="Enter Name"
                                        value={newOptionValue}
                                        onChange={handleChange2}
                                        fullWidth
                                        margin="dense"
                                    />
                                    {showAlert && (
                                        <Alert severity="error" sx={{marginTop: "8px"}}>
                                            Hyphens are not allowed in the name.
                                        </Alert>
                                    )}
                                </div>
                            </DialogContent>
                            <DialogActions sx={{marginRight: "14px"}}>
                                <Button
                                    onClick={() => {
                                        setIsDialogOpen(false);
                                        setNewOptionValue("");
                                    }}
                                    sx={{fontWeight: "bold"}}
                                    variant="outlined"
                                    color="primary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleDialogSubmit}
                                    variant="contained"
                                    color="primary"
                                    sx={{fontWeight: "bold"}}
                                    disabled={!newOptionValue.trim()}
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Snackbar
                            open={snackbaropen}
                            autoHideDuration={5000}
                            onClose={closesnackbar}
                            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                        >
                            <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
                        </Snackbar>
                    </Box>
                    {mediaQueryVar === false && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0",
                                backgroundColor: "white",
                                width: "105%",
                                zIndex: "100",
                                marginLeft: "-10px",
                            }}
                        >
                            <BottomNavigation showLabels>
                                <BottomNavigationAction
                                    label="Top Portfolios"
                                    onClick={() => navigate("/portfolio-gallery")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/portfolio-gallery"
                                                    ? "/images/dashboardS.svg"
                                                    : "/images/dashboardU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="Audit Portfolio"
                                    onClick={() => {
                                        navigate(
                                            userData
                                                ? "/my-portfolio/detailed-portfolio-analysis"
                                                : "/audit-my-portfolio"
                                        );
                                    }}
                                    icon={
                                        <img
                                            src={
                                                loc === "/my-portfolio/detailed-portfolio-analysis"
                                                    ? "/images/portfolioS.svg"
                                                    : "/images/portfolioU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="Crypto Screener"
                                    onClick={() => navigate("/crypto-screener")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/crypto-screener"
                                                    ? "/images/portfolioS.svg"
                                                    : "/images/portfolioU.svg"
                                            }
                                            width={"20px"}
                                            height={"20px"}
                                        />
                                    }
                                />
                            </BottomNavigation>
                        </div>
                    )}
                    {isLoginModalOpen && (
                        <LoginPopUp
                            isLoginModalOpen={isLoginModalOpen}
                            setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                            onClose={handleModalClose}
                        />
                    )}
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "100vh",
                    }}
                >
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0, // aligns it to the right of the sidebar
                            width: "100%", // takes full width minus sidebar
                            backgroundColor: "#ffffff",
                            zIndex: 1000,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            height: "100px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <PromoBanner />
                        <TopNavigationMobile unreadAlerts={unreadAlerts} />
                    </div>

                    <Helmet>
                        <title>Audit My Portfolio</title>
                    </Helmet>

                    <Box
                        component="nav"
                        sx={{
                            width: "100%", // Take full width on mobile
                        }}
                        aria-label="mailbox folders"
                    >
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                "& .MuiDrawer-paper": {
                                    width: drawerWidth, // Adjust width for mobile
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Box>

                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            paddingTop: 3,
                            paddingBottom: 3,
                            paddingLeft: 1,
                            paddingRight: 0,
                            backgroundColor: "white",
                            paddingBottom: "2vw",
                            minHeight: "150vh",
                            marginRight: "6px",
                            overflowY: "auto",
                            paddingTop: "200px",
                        }}
                        className="maindiv"
                    >
                        <TableContainer
                            sx={{
                                width: "100%",
                                borderRadius: "10px",
                                marginTop: "10px",
                                marginLeft: "0px",
                                overflow: "visible",

                                "&::-webkit-scrollbar": {
                                    display: "none",
                                },
                                // Hides scrollbar for Firefox
                                scrollbarWidth: "none",
                                marginBottom: "10px",
                                paddingBottom: "0px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center", // Centers content horizontally
                                    alignItems: "center", // Centers content vertically
                                    height: "100%", // Ensures vertical centering in parent container,
                                }}
                            >
                                {!userData ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "10px 5px",
                                                borderRadius: "8px",
                                                background:
                                                    "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                textAlign: "left",
                                                lineHeight: "1.5",
                                                color: "#000",
                                                width: "100%",
                                            }}
                                        >
                                            <h3
                                                style={{
                                                    marginTop: "0",
                                                    marginBottom: "10px",
                                                    textAlign: "center",
                                                    fontSize: "18px",
                                                    fontWeight: "700",
                                                }}
                                            >
                                                How to Audit Your Crypto Portfolio
                                            </h3>
                                            <ul style={{paddingLeft: "20px", margin: "0"}}>
                                                <li>Click on any cryptocurrency to add; a pop-up will appear.</li>
                                                <li>
                                                    Use the pop-up to create new portfolio and add cryptocurrencies.
                                                </li>
                                                <li>
                                                    Once complete, access the portfolio, click "Analysis" and
                                                    "Recommendations" for portfolio analysis and suggestions.
                                                </li>
                                            </ul>
                                        </div>
                                        <button
                                            onClick={() => {
                                                const originalUrl = "/audit-my-portfolio";
                                                sessionStorage.setItem("originalUrl", originalUrl);
                                                console.log("original url: " + originalUrl);
                                                handleLoginClick();
                                            }}
                                            style={{
                                                border: "1px solid #1877F2",
                                                borderRadius: "48px",
                                                padding: "10px 26px",
                                                backgroundColor: "white",
                                                color: "#1877F2",
                                                fontSize: "18px",
                                                height: "66px",
                                                margin: "20px",
                                                marginLeft: "-5px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            Audit My Portfolio
                                        </button>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            padding: "10px 5px",
                                            borderRadius: "8px",
                                            background:
                                                "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            textAlign: "left",
                                            lineHeight: "1.5",
                                            color: "#000",
                                            width: "100%",
                                        }}
                                    >
                                        <h3
                                            style={{
                                                marginTop: "0",
                                                marginBottom: "10px",
                                                textAlign: "center",
                                                fontSize: "18px",
                                                fontWeight: "700",
                                            }}
                                        >
                                            How to Audit Your Crypto Portfolio
                                        </h3>
                                        <ul style={{paddingLeft: "20px", margin: "0"}}>
                                            <li>Click on any cryptocurrency to add; a pop-up will appear.</li>
                                            <li>Use the pop-up to create new portfolio and add cryptocurrencies.</li>
                                            <li>
                                                Once complete, access the portfolio, click "Analysis" and
                                                "Recommendations" for portfolio analysis and suggestions.
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </TableContainer>

                        {initialPage && <Portfolioadd />}
                        {!initialPage && (
                            <>
                                {selectedButton === "CoinPrices" && (
                                    <>
                                        {selectedButton == "CoinPrices" && (
                                            <Grid
                                                item
                                                xs={12}
                                                md={3}
                                                sx={{
                                                    marginTop: "20px",
                                                    marginRight: "5px",
                                                    marginLeft: "-5px",
                                                    marginBottom: "15px",
                                                }}
                                            >
                                                <TextField
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: "46px",
                                                        marginTop: mediaQueryVar === true ? "" : "0px",
                                                        fontFamily: "Satoshi, sans-serif",
                                                        borderRadius: "46px",
                                                        border: " 1px #1877F2 solid",
                                                        backgroundColor: "#fff",
                                                        paddingTop: "2px",
                                                        paddingBottom: "2px",
                                                        paddingLeft: "12px",
                                                        paddingRight: "30px",
                                                        fontSize: "16px",
                                                        fontWeight: "500",
                                                    }}
                                                    className="cryptocurrencyListHeaderSearch"
                                                    size="small"
                                                    placeholder="Search Cryptos to add"
                                                    onInput={(e) => setFilter(e.target.value)}
                                                    value={filter}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <img src="images/search.svg" />
                                                            </InputAdornment>
                                                        ),
                                                        style: {
                                                            border: "none", // Remove the border from the input
                                                        },
                                                    }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "transparent", // Remove the border of the fieldset
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "transparent", // Remove the border on hover
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "transparent", // Remove the border when focused
                                                            },
                                                            "& input::placeholder": {
                                                                color: "#1877F2",
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                        {loader === false ? (
                                            // Skeleton Loader (5 placeholder cards)
                                            Array.from({length: 5}).map((_, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        background: "white",
                                                        borderRadius: "12px",
                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                        marginBottom: "15px",
                                                        padding: "0px",
                                                        border: "1px solid #1877F2",
                                                        position: "relative",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    {/* Shimmer effect */}
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            background:
                                                                "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)",
                                                            animation: "shimmer 1.5s infinite",
                                                        }}
                                                    ></div>

                                                    {/* Placeholder Content */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            color: "#333",
                                                            background:
                                                                "var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                                                            borderRadius: "28px",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "28px",
                                                                height: "28px",
                                                                borderRadius: "50%",
                                                                background: "#e0e0e0",
                                                                marginRight: "10px",
                                                            }}
                                                        ></div>
                                                        <div
                                                            style={{
                                                                width: "100px",
                                                                height: "16px",
                                                                background: "#e0e0e0",
                                                                borderRadius: "4px",
                                                            }}
                                                        ></div>
                                                    </div>

                                                    <div
                                                        style={{
                                                            width: "98%",
                                                            height: "2px",
                                                            background: "#1877F2",
                                                            marginBottom: "15px",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                        }}
                                                    ></div>

                                                    <div
                                                        style={{
                                                            display: "grid",
                                                            gridTemplateColumns: "1fr 1fr",
                                                            rowGap: "10px",
                                                            fontSize: "14px",
                                                            marginLeft: "10px",
                                                        }}
                                                    >
                                                        {Array.from({length: 4}).map((_, i) => (
                                                            <div
                                                                key={i}
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    marginRight: "10px",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: "80px",
                                                                        height: "14px",
                                                                        background: "#e0e0e0",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                ></div>
                                                                <div
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "14px",
                                                                        background: "#e0e0e0",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                ></div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <button
                                                        style={{
                                                            display: "block",
                                                            width: "90%",
                                                            margin: "15px auto",
                                                            padding: "10px",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            background: "#e0e0e0",
                                                            border: "none",
                                                            borderRadius: "20px",
                                                            textAlign: "center",
                                                            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                                                        }}
                                                    ></button>
                                                </div>
                                            ))
                                        ) : sortedSlugdata.length === 0 ? (
                                            // No Data Message
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                    border: "2px solid #1877F2",
                                                    borderRadius: "12px",
                                                    color: "#1877F2",
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    background: "rgba(24, 119, 242, 0.1)",
                                                }}
                                            >
                                                No Crypto Found
                                            </div>
                                        ) : (
                                            sortedSlugdata.map((coin, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        background: "white",
                                                        borderRadius: "12px",
                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                        marginBottom: "15px",
                                                        padding: "0px",
                                                        border: "1px solid #1877F2",
                                                    }}
                                                >
                                                    {/* Crypto Name and Logo */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            marginBottom: "1px",
                                                            alingItems: "center",
                                                            background:
                                                                "var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                                                            borderRadius: "28px",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontWeight: "bold",
                                                                fontSize: "16px",
                                                                color: "#333",
                                                            }}
                                                        >
                                                            <img
                                                                src={coin.logo}
                                                                alt={coin.name}
                                                                style={{
                                                                    width: "28px",
                                                                    height: "28px",
                                                                    borderRadius: "50%",
                                                                    marginRight: "10px",
                                                                }}
                                                            />
                                                            {coin.name}
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginRight: "10px",
                                                                marginTop: "3px",
                                                                minWidth: "60px",
                                                                color: "#1877F2",
                                                                padding: "5px 12px",
                                                                borderRadius: "26px",
                                                                fontSize: "12px",
                                                                fontWeight: "bold",
                                                                border: "1px solid #1877F2",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {coin.category}
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: "98%",
                                                            height: "2px",
                                                            background: "#1877F2",
                                                            marginBottom: "15px",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                        }}
                                                    ></div>

                                                    {/* Left-Right Two-Column Layout */}
                                                    <div style={{fontSize: "16px", marginLeft: "10px"}}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                marginRight: "5px",
                                                                gap: "10px",
                                                            }}
                                                        >
                                                            <span>Price</span>
                                                            <span style={{fontWeight: "bold"}}>{coin.price_today}</span>
                                                        </div>
                                                    </div>

                                                    <div style={{display: "flex", alignItems: "center"}}>
                                                        {/* Add To Portfolio Button */}
                                                        <button
                                                            onClick={() => handleAddToPortfolio(coin.slug)}
                                                            style={{
                                                                display: "block",
                                                                width: "45%",
                                                                margin: "15px auto",
                                                                padding: "6px 10px",
                                                                fontSize: "15px",
                                                                fontWeight: "bold",
                                                                background:
                                                                    "linear-gradient(180deg, rgba(24, 119, 242, 0.20) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                                                borderRadius: "30px",
                                                                boxShadow:
                                                                    " 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                                cursor: "pointer",
                                                                textAlign: "center",
                                                                color: "#1877F2",
                                                                border: "2px solid #1877F2",
                                                            }}
                                                        >
                                                            Add To Portfolio
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}

                                        {addMoreLoader && (
                                            <div style={{width: "100%", marginBottom: "100px"}}>
                                                <div
                                                    className="loader-container"
                                                    style={{display: "flex", justifyContent: "center"}}
                                                >
                                                    <div className="spinner"></div>
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            ref={observerRef}
                                            className="observer-trigger"
                                            style={{visibility: "hidden"}}
                                        ></div>
                                        {loaderForSymbolLink === true && (
                                            <div>
                                                <CircularProgress
                                                    style={{position: "fixed", top: "40vh", left: "45vw"}}
                                                />
                                            </div>
                                        )}
                                        <style>
                                            {`
                                             @keyframes spin {
                                               0% { transform: rotate(0deg); }
                                               100% { transform: rotate(360deg); }
                                             }
                                       
                                             .spinner {
                                               width: 40px;
                                               height: 40px;
                                               border: 4px solid rgba(67, 97, 238, 0.3);
                                               border-top: 4px solid #4361ee;
                                               border-radius: 50%;
                                               animation: spin 1s linear infinite;
                                             }
                                       
                                           `}
                                        </style>
                                    </>
                                )}
                                {selectedButton === "watchlist" && (
                                    <>
                                        <WatchListGallery filter={filter} onButtonClick={handleButtonClick} />
                                    </>
                                )}
                            </>
                        )}
                        {loaderForSymbolLink === true && (
                            <div>
                                <CircularProgress style={{position: "fixed", top: "40vh", left: "45vw"}} />
                            </div>
                        )}
                    </Box>
                    <Modal
                        sx={{overflow: "hidden"}}
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <div className="CardOpener" style={{overflow: "hidden"}}>
                            {isFormSubmitted ? (
                                <Card className="card__container" style={{marginTop: "60%"}}>
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <CheckCircleOutlineIcon sx={{fontSize: 50, mr: 1}} />
                                        </div>
                                        <Typography
                                            severity="success"
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            Portfolio added successfully!
                                        </Typography>
                                    </>
                                    <div style={{display: "flex", justifyContent: "space-evenly"}}>
                                        <Button
                                            onClick={() => {
                                                setIsFormSubmitted(false);
                                                setOpen(false);
                                                setUnit("");
                                                setSelectedOption("");
                                                setPrice("");
                                                setTotalUnits(0);
                                                handleDateChange("");
                                                setUsablewallet("");
                                            }}
                                            color="primary"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "150px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                        >
                                            Add More Cryptos
                                        </Button>
                                        <Button
                                            onClick={() =>
                                                navigate(
                                                    `/my-portfolio/${portfolioTypeId}/${encodeURIComponent(
                                                        selectedOption.label
                                                    )}`
                                                )
                                            }
                                            variant="outlined"
                                            style={{
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                whiteSpace: "nowrap",
                                                float: "inline-end",
                                                width: mediaQueryVar === true ? "100px" : "100px",
                                                height: mediaQueryVar === false ? "30px" : "",
                                                fontSize: mediaQueryVar === false ? "10px" : "11px",
                                            }}
                                            color="primary"
                                        >
                                            View Portfolio
                                        </Button>
                                    </div>
                                </Card>
                            ) : (
                                <Dialog
                                    PaperProps={{
                                        sx: {
                                            position: mediaQueryVar ? "static" : "fixed",
                                            bottom: mediaQueryVar ? "" : 0,
                                            left: mediaQueryVar ? "" : 0,
                                            right: mediaQueryVar ? "" : 0,
                                            margin: "0",
                                            maxWidth: "100%",
                                            minHeight: "50%", // Adjust max height if needed
                                            borderRadius: mediaQueryVar ? "24px" : "24px 24px 0 0",
                                            padding: "10px",
                                            alignItems: "center",
                                            overflow: "scroll",
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                            "-ms-overflow-style": "none",
                                            "scrollbar-width": "none", // Ensure no scrollbar
                                        },
                                    }}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <div
                                        style={{
                                            padding: "20px",
                                            width: mediaQueryVar === false ? "100%" : "400px",
                                            margin: "0",
                                            marginTop: "-5px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "20px",
                                                borderBottom: "1px #E3E3E3 solid",
                                            }}
                                        >
                                            <Typography
                                                style={{fontWeight: "500", fontSize: "20.767px", paddingLeft: "25%"}}
                                                gutterBottom
                                            >
                                                Add To Portfolio
                                            </Typography>

                                            <div className="primaryButton">
                                                <img
                                                    className="frameIcon"
                                                    alt=""
                                                    onClick={handleClose}
                                                    src={window.constants.asset_path + "/images/frame17.svg"}
                                                    style={{background: "#F3F3F3", width: "25px", height: "25px"}}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                marginBottom: "5px",
                                                marginLeft: mediaQueryVar === false ? "5px" : "",
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    fontSize: "13.845px",
                                                    fontWeight: "500",
                                                    marginBottom: "1px",
                                                    color: "black",
                                                    marginTop: "-8px",
                                                }}
                                            >
                                                Select Portfolio
                                            </Typography>
                                            <div style={{marginTop: "5px"}}>
                                                <CreatableSelect
                                                    isClearable
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "12px",
                                                            border: "1px solid #1877F2",
                                                            boxShadow: "none",
                                                            minHeight: "40px",
                                                            "&:hover": {
                                                                borderRadius: "12px",
                                                                border: "2px solid #1877F2",
                                                            },
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            borderRadius: "8px",
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: "",
                                                        }),
                                                        dropdownIndicator: (provided) => ({
                                                            ...provided,
                                                            color: "#1877F2",
                                                            border: "1px solid #1877F2",
                                                            padding: "5px",
                                                            margin: "8px",
                                                            borderRadius: "3.786px",
                                                            "&:hover": {
                                                                color: "#1877F2",
                                                            },
                                                        }),
                                                        indicatorSeparator: (provided) => ({
                                                            display: "none",
                                                        }),
                                                    }}
                                                    placeholder=""
                                                    onChange={(options) =>
                                                        handleChange(options, slugpopupdata.slugname)
                                                    }
                                                    onCreateOption={handleCreate}
                                                    options={[
                                                        {value: "", label: "Create new portfolio", _isNew_: true}, // Dynamic "create new option" item
                                                        ...options, // Existing options
                                                    ]}
                                                    value={selectedOption}
                                                />
                                            </div>
                                            {showAlert && (
                                                <Alert severity="error" sx={{marginBottom: "10px"}}>
                                                    {errorMessage}
                                                </Alert>
                                            )}
                                        </div>
                                        <Typography
                                            style={{
                                                fontSize: "13.845px",
                                                fontWeight: "500",
                                                color: "#000",
                                                marginTop: "10px",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            Usable Wallet Value: {Usablewallet}
                                        </Typography>
                                        <div
                                            style={{
                                                padding: "8px",
                                                background: "#F3F3F3",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div style={{display: "flex", alignItems: "center", flex: 0, minWidth: 0}}>
                                                <img
                                                    style={{
                                                        marginRight: "10px",
                                                        border: "2px solid #000",
                                                        borderRadius: "19px",
                                                        height: "27.69px",
                                                        width: "27.69px",
                                                    }}
                                                    alt=""
                                                    src={slugpopupdata.logo}
                                                />
                                                <div style={{display: "flex", flexDirection: "column"}}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            marginBottom: "4px",
                                                            fontSize: "14px",
                                                            color: "#7F7F80",
                                                        }}
                                                    >
                                                        {slugpopupdata.slugname}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "black",
                                                            margin: "0",
                                                        }}
                                                    >
                                                        {slugpopupdata.slug}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "20px",
                                                    flex: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Price
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    {slugpopupdata.pricetoday}
                                                </Typography>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginLeft: "20px",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: "500",
                                                        marginBottom: "4px",
                                                        fontSize: "13px",
                                                        color: "#7F7F80",
                                                    }}
                                                >
                                                    {" "}
                                                    Units
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "12.114px",
                                                        fontWeight: "500",
                                                        color: "black",
                                                        margin: "0",
                                                    }}
                                                >
                                                    {totalUnits}
                                                </Typography>
                                            </div>
                                        </div>
                                        <div className="card__container__row3">
                                            <div style={{marginLeft: "-5px"}}>
                                                <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                    Enter number of Units
                                                </p>
                                                <input
                                                    style={{
                                                        backgroundColor: "white",
                                                        color: "black",
                                                        padding: "20px",
                                                        border: "1px solid #1877F2",
                                                        borderRadius: "10.384px",
                                                        width: "100%",
                                                        height: "45px",
                                                        margin: 0,
                                                    }}
                                                    min="1"
                                                    max="10"
                                                    type="number"
                                                    placeholder=""
                                                    value={unit}
                                                    onChange={(e) => setUnit(e.target.value)}
                                                ></input>
                                            </div>
                                            <div>
                                                $
                                                {formatToNonZero(
                                                    unit *
                                                        parseFloat((slugpopupdata.pricetoday || "").replace(/^\$/, ""))
                                                )}
                                            </div>
                                            {user_role === "superuser" && (
                                                <>
                                                    <div className="card__container__row3__r2">
                                                        <div style={{marginLeft: "-5px"}}>
                                                            <p style={{fontSize: "14px", fontWeight: "500"}}>
                                                                Buy/Sell Price($)
                                                            </p>
                                                            <input
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    color: "black",
                                                                    padding: "20px",
                                                                    border: "1px solid #1877F2",
                                                                    borderRadius: "10.384px",
                                                                    width: "100%",
                                                                    height: "45px",
                                                                }}
                                                                className="card__container__row3__r2__input"
                                                                min="1"
                                                                max="10"
                                                                type="number"
                                                                placeholder="Enter Price"
                                                                value={price}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                            ></input>
                                                        </div>
                                                    </div>
                                                    <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                                                        <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                                                        <TextField
                                                            type="date"
                                                            value={selectedDate}
                                                            onChange={(e) => handleDateChange(e.target.value)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "10.384px",
                                                                    border: "1px solid #1877F2",
                                                                    boxShadow: "none",
                                                                    width: "190%",
                                                                    height: "45px",
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="card__container__row3__r4" style={{marginTop: "10px"}}>
                                                <Button
                                                    className={
                                                        buySell === "buy" ? "buttonToggleButActive" : "buttonToggleBuy"
                                                    }
                                                    value="Buy"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "45%",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        padding: "15px 8px",
                                                        marginLeft: "5px",
                                                        backgroundColor: buySell === "buy" ? "" : "#1877F2",
                                                        color: buySell === "buy" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("buy")}
                                                >
                                                    Add
                                                </Button>
                                                <Button
                                                    className={
                                                        buySell === "sell"
                                                            ? "buttonToggleSellActive"
                                                            : "buttonToggleSell"
                                                    }
                                                    value="sell"
                                                    style={{
                                                        lineHeight: "20px",
                                                        width: "45%",
                                                        borderRadius: "27px",
                                                        border: "1px solid #1877F2",
                                                        marginLeft: "5px",
                                                        marginRight: "10px",
                                                        padding: "15px 8px",
                                                        backgroundColor: buySell === "sell" ? "" : "#1877F2",
                                                        color: buySell === "sell" ? "" : "white",
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: "700",
                                                    }}
                                                    onClick={() => handleClick("sell")}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog>
                            )}
                        </div>
                    </Modal>
                    <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle>
                            Create New Portfolio
                            <IconButton
                                aria-label="close"
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{position: "absolute", right: 13, top: 8}}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <div>
                                <TextField
                                    autoFocus
                                    label="Enter Name"
                                    value={newOptionValue}
                                    onChange={handleChange2}
                                    fullWidth
                                    margin="dense"
                                />
                                {showAlert && (
                                    <Alert severity="error" sx={{marginTop: "8px"}}>
                                        Hyphens are not allowed in the name.
                                    </Alert>
                                )}
                            </div>
                        </DialogContent>
                        <DialogActions sx={{marginRight: "14px"}}>
                            <Button
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setNewOptionValue("");
                                }}
                                sx={{fontWeight: "bold"}}
                                variant="outlined"
                                color="primary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDialogSubmit}
                                variant="contained"
                                color="primary"
                                sx={{fontWeight: "bold"}}
                                disabled={!newOptionValue.trim()}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Snackbar
                        open={snackbaropen}
                        autoHideDuration={5000}
                        onClose={closesnackbar}
                        anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                    >
                        <Alert severity={severity}>{msgforUpdatePortfolio}</Alert>
                    </Snackbar>

                    {mediaQueryVar === false && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0",
                                backgroundColor: "white",
                                width: "100%",
                                zIndex: "100",
                                marginTop: "5px",
                            }}
                        >
                            <BottomNavigation showLabels>
                                <BottomNavigationAction
                                    label="Top Portfolios"
                                    onClick={() => navigate("/portfolio-gallery")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/portfolio-gallery"
                                                    ? "/images/dashboardS.svg"
                                                    : "/images/dashboardU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="My Portfolios"
                                    onClick={() => {
                                        navigate(
                                            userData
                                                ? "/my-portfolio/detailed-portfolio-analysis"
                                                : "/audit-my-portfolio"
                                        );
                                    }}
                                    icon={
                                        <img
                                            src={
                                                loc === "/my-portfolio/detailed-portfolio-analysis"
                                                    ? "/images/portfolioS.svg"
                                                    : "/images/portfolioU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="Screener"
                                    onClick={() => navigate("/crypto-screener")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/crypto-screener"
                                                    ? "/images/portfolioS.svg"
                                                    : "/images/portfolioU.svg"
                                            }
                                            width={"20px"}
                                            height={"20px"}
                                        />
                                    }
                                />
                            </BottomNavigation>
                        </div>
                    )}
                    {isLoginModalOpen && (
                        <LoginPopUp
                            isLoginModalOpen={isLoginModalOpen}
                            setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                            onClose={handleModalClose}
                        />
                    )}
                </Box>
            )}
        </>
    );
};

export default NewUserAudit;
